const { APP_CONFIG = {} } = typeof window !== 'undefined' ? window : {}

function getConf(overrideValue, envValue, defaultValue) {
  if (overrideValue != null) {
    return overrideValue
  }

  if (envValue != null) {
    return envValue
  }

  return defaultValue
}

// All this file does really is exporting this object of configuration. It is a
// bit verbose because of Flow. That's a small price to pay for typo checking of
// the config keys, though!
//
// Note that we can't do `process.env[name]` because webpack needs to statically
// replace exact `process.env.FOO` pieces of code with values.
export default {
  API_ENDPOINT: getConf(
    APP_CONFIG.API_ENDPOINT,
    process.env.API_ENDPOINT,
    'http://localhost:8000',
  ),
  API_OVERRIDE: getConf(
    APP_CONFIG.API_OVERRIDE,
    process.env.API_OVERRIDE,
    'http://api:8000',
  ),
  OAUTH2_CLIENT_ID: getConf(
    APP_CONFIG.OAUTH2_CLIENT_ID,
    process.env.OAUTH2_CLIENT_ID,
    '',
  ),
  SOCKER_URI: getConf(
    APP_CONFIG.SOCKER_URI,
    process.env.SOCKER_URI,
    'ws://localhost:8765',
  ),
  GM_API_KEY: getConf(APP_CONFIG.GM_API_KEY, process.env.GM_API_KEY, ''),
  SENTRY_DSN: getConf(APP_CONFIG.SENTRY_DSN, process.env.SENTRY_DSN, ''),
  ENV: getConf(APP_CONFIG.ENV, process.env.ENV, 'live'),
}



// WEBPACK FOOTER //
// ../source/config.js